// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--JY9IK","title":"_0fce717cdb--title--EmQLR","description":"_0fce717cdb--description--wKP87"};